import Alert from "components/atoms/alert/Alert";

const TITLE_TEXT_MAX_LENGTH = 255;
const TITLE_TEXT_MAX_LENGTH_ERROR_MESSAGE = "최대 255자까지 입력 가능합니다.";

export const validateTitleTextMaxLength = (value, callback) => {
    if (String(value || "").length <= TITLE_TEXT_MAX_LENGTH) {
        return true;
    }
    Alert("warn", "에러", TITLE_TEXT_MAX_LENGTH_ERROR_MESSAGE, callback);
    return false;
};
